const CLIENT_STATUS = {
  LIBERADA: { label: 'Pendiente de tu confirmación', color: 'warning', description: '' },
  ENTREGADA: { label: 'Recibido', color: 'success', description: '' },
  EN_REVISION: { label: 'En revisión por CONEM', color: 'info', description: 'Tus documentos están en revisión de calidad. Te avisaremos por correo cuando estén listos.' },
  PROGRAMADA: { label: 'Visita programada', color: 'default', description: 'Estamos preparando tu servicio. Te avisaremos cuando tus documentos estén listos.' }
};

export const clientEntityStatus = (entity) => {
  const status = CLIENT_STATUS[entity?.stage] || CLIENT_STATUS.PROGRAMADA;
  if (entity?.stage === 'PROGRAMADA' && entity?.scheduledDate) {
    const date = new Date(`${entity.scheduledDate}T12:00:00`).toLocaleDateString('es-MX', { dateStyle: 'long' });
    return { ...status, description: `Visita programada para el ${date}. Te avisaremos cuando tus documentos estén listos.` };
  }
  return status;
};

const ORDER = { LIBERADA: 0, EN_REVISION: 1, PROGRAMADA: 2, ENTREGADA: 3 };

export const groupByCompany = (entities) => {
  const groups = new Map();
  [...entities]
    .sort((a, b) => (ORDER[a.stage] ?? 9) - (ORDER[b.stage] ?? 9))
    .forEach((entity) => {
      const key = entity.companyName || '';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(entity);
    });
  return [...groups.entries()].map(([companyName, list]) => ({ companyName, entities: list }));
};
